import { KeyboardEvent } from 'react'

export const handleTabByKeyboard = (
  e: KeyboardEvent<HTMLElement>,
  options: { key: string }[],
  current: string,
  setCurrentTab: (key: string) => void
) => {
  const eventType = e.key
  const arrowRight = eventType === 'ArrowRight'
  const arrowLeft = eventType === 'ArrowLeft'
  const keyOptions = options.map(({ key }) => key)
  const index = keyOptions.indexOf(current)

  if (arrowRight) {
    if (index === options.length - 1) {
      return setCurrentTab(keyOptions[0])
    } else {
      return setCurrentTab(keyOptions[index + 1])
    }
  }

  if (arrowLeft) {
    if (index === 0) {
      return setCurrentTab(keyOptions[keyOptions.length - 1])
    } else {
      return setCurrentTab(keyOptions[index - 1])
    }
  }
}
